export enum StorageKeys {
  HAS_SEEN_TUTORIAL = "HAS_SEEN_TUTORIAL",
  HAS_SEEN_INTRO = "HAS_SEEN_INTRO",
  ALLOW_SERVICE_REQUESTS = "ALLOW_SERVICE_REQUESTS",
  WEB_APP_ACCESS_TOKEN_COOKIE = "WEBAPP_ACCESS_TOKEN",
  WEB_APP_ID_TOKEN_COOKIE = "WEBAPP_ID_TOKEN",
  WEB_APP_REFRESH_TOKEN_COOKIE = "WEBAPP_REFRESH_TOKEN",
}
